export * from './feed.model';
export * from './feed-popup.service';
export * from './feed.service';
export * from './feed-dialog.component';
export * from './feed-delete-dialog.component';
export * from './feed-detail.component';
export * from './feed.component';
export * from './feed.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/feed/index.ts